import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Col, Form, Input, Row, Upload, message } from "antd";

const handleSelectTenderFile = ({ file, event }) => {
  // onChange handler for the Upload component fires 3 times, (start, in progress, finish)
  // event is only supplied for in progress, but since this is a local upload, in progress will already be 100 percent done
  // We return early if event is not supplied to prevent error messages from showing multiple times
  if (!event) return;
  const fileReader = new FileReader();

  fileReader.onload = () => {
    try {
      const lines = fileReader.result.split(/\r?\n/);
      let filledForm = false;

      lines.forEach(line => {
        if (line.substr(0, 3) === "HDR") {
          this.wwlIntegrationFormRef.current.setFieldsValue({
            vpc: line.substr(3, 2),
            railHead: line.substr(5, 3),
            carrierCode: line.substr(8, 5),
            seqNum: line.substr(23, 4),
          });
          filledForm = true;
          return;
        }
      });

      if (!filledForm) {
        message.warning("No HDR section found in tender file");
      }
    } catch (err) {
      message.error("Error parsing tender file.");
      console.error(err.message);
    }
  };

  try {
    fileReader.readAsText(file.originFileObj);
  } catch (err) {
    message.error("Error reading tender file.");
    console.error(err.message);
  }
};

const IntegrationInputs = ({ wwlIntegrationFormRef, edit }) => {
  return (
    <Row gutter={16} style={{ marginTop: 16 }}>
      <Col flex={1}>
        <Card className="noLeftMarginCard" title="Additional Info">
          {edit ? (
            <Alert
              message="WWL Integration"
              description={
                <div>
                  <span>
                    This dealer has a WWL integration in the system. Please enter additional required information from
                    the tender file:
                  </span>
                  <br />
                </div>
              }
              type="info"
              showIcon
              style={{ width: "100%", marginBottom: 16 }}
            />
          ) : (
            <Alert
              message="WWL Integration"
              description={
                <div>
                  <span>
                    This shipment has a WWL integration in the system. Additional information related to this
                    integration is displayed below.
                  </span>
                  <br />
                  <Upload
                    onChange={handleSelectTenderFile}
                    multiple={false}
                    maxCount={1}
                    showUploadList={false}
                    accept=".TE, .txt"
                  >
                    <Button style={{ marginTop: 16 }} icon={<UploadOutlined />}>
                      Select Tender File
                    </Button>
                  </Upload>
                </div>
              }
              type="info"
              showIcon
              style={{ width: "100%", marginBottom: 16 }}
            />
          )}

          <Form ref={wwlIntegrationFormRef} layout="vertical">
            <Form.Item name="vpc" label="VPC" rules={[{ required: true, max: 2 }]}>
              <Input />
            </Form.Item>
            <Form.Item name="railHead" label="Rail Head" rules={[{ required: true, max: 3 }]}>
              <Input />
            </Form.Item>
            <Form.Item name="carrierCode" label="Carrier Code" rules={[{ required: true, max: 5 }]}>
              <Input />
            </Form.Item>
            <Form.Item name="sequenceNumber" label="Sequence Number" rules={[{ required: true, max: 4 }]}>
              <Input />
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default IntegrationInputs;
